import * as Sentry from '@sentry/browser';

// Can't use $wr methods!
// No $wr.isProduction specifically

export function isActive() {
	return false; //DISABLE SENTRY FOR WEB CLIENT BECAUSE OF JS ERRORS OVERFLOWING SENTRY CREDIT
	// return process.env.NODE_ENV === "production";
}

const IGNORE_ERRORS = [
	{ value: "Network request failed" },
	{ value: "Unexpected end of JSON input" },
	{ type: "UnhandledRejection" },
	{ type: "NS_ERROR_FAILURE" },

	// Something inside of react-tooltip I can't get a handle on.
	// My guess is something timing related with on
	{ value: "Cannot read property 'getBoundingClientRect' of null" },
	
	{ value: "ResizeObserver loop limit exceeded" },

	{ type: "WR APIError 500" },
	{ type: "WR APIError 404" },
	{ type: "WR APIError 403" },
	{ type: "WR APIError 401" }
]

export function init() {
	if (!isActive()) { return; }

	var checkpoint = (new Date()).valueOf();
	var checkpointCount = 0;
	const CHECKPOINT_LIMIT = 3;
	const CHECKPOINT_LENGTH = 30 * 1000;

	Sentry.init({
		dsn: "https://7549e9fb52124a38b3bc617c2f231f17@sentry.io/1731988",

		beforeSend: (event) => {
			// The ignoreErrors thing was being flaky
			var exception = event.exception.values[0]
			if (exception) {
				for (let i = 0; i < IGNORE_ERRORS.length; i+=1) {
					var ignore = IGNORE_ERRORS[i];
					if (ignore.value && (ignore.value == exception.value)) {
						return null;
					}

					if (ignore.type && (ignore.type == exception.type)) {
						return null;
					}
				}
			}

			// Limits errors to at most 3 per 30 seconds
			var now = (new Date()).valueOf();

			if (checkpoint + CHECKPOINT_LENGTH < now) {
				checkpointCount = 0;
				checkpoint = now;
			}
			checkpointCount += 1;
			if (checkpointCount > CHECKPOINT_LIMIT) {
				console.log("Filtering sentry errors, error count: " + checkpointCount)
				return null;
			}

			if ($wr.isDevelopment()) {
				console.log("Sending error", exception)
			}

			return event;
		}

	});
}

export function setUserContext(user) {
	if (!isActive()) { return; }

	var userData = {
		user_id: user.id,
		demo: user.demo,
		product: user.product,
		role: user.role
	};

	if (user.role != "studentRole") {
		userData.full_name = user.first_name + " " + user.last_name;
		userData.email = user.email;
	}


	if (user.primary_student_list && user.primary_student_list.primary_admin) {
		userData.teacher_user_id = user.primary_student_list.primary_admin.id;
	}

	Sentry.configureScope((scope) => {
		scope.setUser(userData);
	});

}



// WEBPACK FOOTER //
// ./modules/lib/integrations/SentryClient.js